import { MAX_SCROLL_DELTA, MAX_SCROLL_SENSITIVITY } from './consts';
import { ScrollValues } from './ScrollValues';
import { clamp } from 'lodash';

export class Scroller {
  private scrollDeltaX = 0;
  private scrollDeltaY = 0;
  private scrollInterval = 0;
  private scrollContainer: HTMLElement | null;
  private box: DOMRect;
  scrollValues: ScrollValues;
  constructor(scrollContainer: HTMLElement, controller: AbortController) {
    this.scrollContainer = scrollContainer;
    this.box = scrollContainer.getBoundingClientRect();
    this.scrollValues = new ScrollValues(
      scrollContainer.scrollTop,
      scrollContainer.scrollLeft
    );
    document.addEventListener('mousemove', this.moveHandler, {
      signal: controller.signal,
    });
    scrollContainer.addEventListener('scroll', this.scrollHandler, {
      passive: true,
      signal: controller.signal,
    });
    controller.signal.addEventListener('abort', () => {
      this.scrollContainer = null;
      window.clearInterval(this.scrollInterval);
    });
  }
  private moveHandler = ({ clientX, clientY }: MouseEvent) => {
    if (!this.scrollContainer) return;
    const deltaX =
      clientX < this.box.left
        ? clientX - this.box.left
        : clientX > this.box.right
          ? clientX - this.box.right
          : 0;
    const deltaY =
      clientY < this.box.top
        ? clientY - this.box.top
        : clientY > this.box.bottom
          ? clientY - this.box.bottom
          : 0;
    const directionX = deltaX < 0 ? -1 : 1;
    const directionY = deltaY < 0 ? -1 : 1;
    const deltaPercentX =
      clamp(0, Math.abs(deltaX), MAX_SCROLL_SENSITIVITY) /
      MAX_SCROLL_SENSITIVITY;
    const deltaPercentY =
      clamp(0, Math.abs(deltaY), MAX_SCROLL_SENSITIVITY) /
      MAX_SCROLL_SENSITIVITY;
    this.scrollDeltaX =
      directionX * Math.pow(deltaPercentX, 2) * MAX_SCROLL_DELTA;
    this.scrollDeltaY =
      directionY * Math.pow(deltaPercentY, 2) * MAX_SCROLL_DELTA;
    this.startOrStopScollIfNeeded();
  };
  private scrollHandler = () => {
    if (!this.scrollContainer) return;
    this.scrollValues.currentScrollLeft = this.scrollContainer.scrollLeft;
    this.scrollValues.currentScrollTop = this.scrollContainer.scrollTop;
  };
  private scroll = () => {
    if (!this.scrollContainer) return;
    this.scrollContainer.scrollLeft += this.scrollDeltaX;
    this.scrollContainer.scrollTop += this.scrollDeltaY;
  };
  private startOrStopScollIfNeeded() {
    if (this.scrollDeltaX === 0 && this.scrollDeltaY === 0) {
      if (this.scrollInterval) {
        this.scrollInterval = (window.clearInterval(this.scrollInterval), 0);
      }
      return;
    }
    if (this.scrollInterval) return;
    this.scrollInterval = window.setInterval(this.scroll, 16);
  }
}
